export default {
    FETCH_GRID_DATA_STATIC_DATA: "FETCH_GRID_DATA_STATIC_DATA",
};